/**
 * Where a reader of the sim's per-tick event buffer has got to. A command's events are appended to the buffer of the
 * tick they land in, and the level hands the buffer over again after each command (levelController.execute), so a
 * reader that walks the whole buffer each time replays the tick's earlier events: a TIER ribbon shown twice, a kill
 * counted twice by the moments. `next` returns the index of the first event this reader has not seen and marks the
 * rest seen; a new tick (the buffer was cleared) starts from 0.
 */
export class EventCursor {
  private tick = -1;
  private count = 0;

  next(sim: { readonly tick: number; readonly events: { readonly count: number } }): number {
    const tick = sim.tick, count = sim.events.count;
    const from = this.tick === tick && this.count <= count ? this.count : 0;
    this.tick = tick;
    this.count = count;
    return from;
  }
}
